export const CREATE_CAR = "CREATE_CAR";
export const UPDATE_CAR = "UPDATE_CAR";
export const DELETE_CAR = "DELETE_CAR";
export const FETCH_CARS = "FETCH_CARS";
export const LISTEN_TO_SELECTED_CAR = "LISTEN_TO_SELECTED_CAR";
